import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Divider, Sidebar } from 'semantic-ui-react'
import { El } from '~/components/Layout/style'
import { SidebarContainer } from './style'
import { ReactSortable } from 'react-sortablejs';

interface SortSidebarProps {
  items: any[]
  isVisible: boolean
  handleSave: (sortedGroups: any) => void
  onClose: () => void
  groupId?: string
}

const SortSidebar: React.FC<SortSidebarProps> = (props) => {
  const { t } = useTranslation()
  const { isVisible, handleSave } = props
  const [items, setItems] = useState([])

  useEffect(() => {
    setItems(props.items)
  }, [props.items])

  function renderHeader() {
    const title = props.items[0]?.questions ? t('Sort groups') : t('Sort questions')
    return <div>
      <div className='header-wrapper'>
        <div className='title'>{title}</div>
        <div>
          <El.PageHeaderActionButton
            onClick={() => {
              if (props.groupId) {
                handleSave({ sortedQuestions: items?.map(item => item?.id) || [] })
              } else {
                handleSave({ sortedGroups: items?.map(item => item?.id) || [] })
              }
            }}
          >{t('Save sort')}</El.PageHeaderActionButton>
          <El.PageHeaderActionButton
            onClick={() => props.onClose()}
          >{t('Close')}</El.PageHeaderActionButton>
        </div>
      </div>
      <Divider />
    </div>
  }

  function renderItems() {
    return items.map((item, index) => {
      return <div className='question-name' key={item.id}>
        {`${index + 1}. ${item?.question || item.name}`}
      </div>
    })
  }

  return <SidebarContainer>
    <Sidebar
      className='drawer'
      animation='push'
      direction='right'
      onHide={() => props.onClose}
      visible={isVisible}
      width='very wide'
    >
      {renderHeader()}
      <ReactSortable
        list={items}
        animation={150}
        delayOnTouchOnly={true}
        delay={2}
        setList={setItems}
      >
        {renderItems()}
      </ReactSortable>
    </Sidebar>
  </SidebarContainer>
}
export default SortSidebar